export var MediumEnum;
(function (MediumEnum) {
    MediumEnum["JUPITER_DESKTOP"] = "Jupiter-desktop";
    MediumEnum["JUPITER_WEB"] = "Jupiter-web";
    MediumEnum["MTHOR_IOS"] = "mThor-iOS";
    MediumEnum["MTHOR_ANDROID"] = "mThor-Android";
    MediumEnum["TEAMS"] = "Teams";
    MediumEnum["WEB"] = "web";
})(MediumEnum || (MediumEnum = {}));
